// @ts-strict-ignore
import { css } from 'styled-components';
// eslint-disable-next-line import/no-namespace
import * as ss from 'styled-system';

import { fontWeights, transition } from 'theme';

export const buttonSize = (props: {
  fontSize?: string | number;
  p?: string | number;
  size?: 'small' | 'medium' | 'large';
}) => {
  switch (props.size) {
    case 'small':
      return {
        fontSize: props.fontSize || '14px',
        padding: !props.p && '0.4em 1.2em',
      };

    case 'large':
      return {
        fontSize: props.fontSize || '18px',
        padding: !props.p && '12px 24px',
      };

    default:
      return {
        fontSize: props.fontSize || '16px',
        padding: !props.p && '8px 16px',
      };
  }
};

export const buttonStylesMinimal = `
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  text-decoration: none;
  font-family: inherit;
  font-weight: ${fontWeights.normal};
  letter-spacing: 0.5px;
  line-height: 1.25;
  cursor: pointer;
  border-radius: 8px;
  transition: all ${transition};
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const buttonStyles = css<{
  fontSize: string | number;
  p: string | number;
  size?: 'small' | 'medium' | 'large';
}>`
  ${buttonStylesMinimal}
  ${buttonSize}
  ${ss.borderRadius}
  ${ss.boxShadow}
`;
